<template>
	<event-header :model="tEvent" :editing="editing" model_name="event" :has_image="tEvent.image !== ''" :is_live_event="apply_live_style">
		<!--<template v-slot:back-button>
			<div class="tw-inline-flex">
				<template v-if="editing">
					<router-link :to="{name: 'events.show', params: { event_slug: tEvent.slug }}" class="groups-events-back-btn">
						<i class="fal fa-angle-left"></i>
						<p>{{ translations['groups.back_to'] }} {{ translations['groups.singular'].toLowerCase() }}</p>
					</router-link>
				</template>
				<template v-else>
					<router-link :to="{name: 'events.index'}" class="groups-events-back-btn">
						<i class="fal fa-angle-left"></i>
						<p>{{ translations['groups.back_to'] }} {{ translations['groups.singular'].toLowerCase() }} {{ translations['groups.overview'] }}</p>
					</router-link>
				</template>
			</div>
		</template>-->

		<template v-slot:content>
			<div v-if="apply_live_style" class="tw-flex tw-items-center tw-flex-col">
				<h1 v-line-clamp:23="2" v-text="tEvent.title" class="tw-font-semibold tw-text-center tw-text-white"></h1>
				<p class="tw-text-center tw-mb-7 tw-text-white">{{ tEvent.live_room.status === 'ENDED' ? $t('events.has_ended') : start_date }}</p>
				<countdown ref='countdown' v-if="!start_date_has_passed && tEvent && (tEvent.live_room.status === 'PLANNED' || tEvent.live_room.status === 'STAGING')" :deadline="tEvent.start_date" @countdownFinished="start_date_has_passed = true"></countdown>
                <span v-if="start_date_has_passed && (tEvent.live_room.status === 'PLANNED' || tEvent.live_room.status === 'STAGING')" class="countdown-finished-message">{{ $t('live.starting_soon') }}</span>
                <span v-else-if="tEvent.live_room.status === 'STARTED'" class="countdown-finished-message"><i class="fas fa-circle fa-sm tw-mr-1 tw-text-red-500 live-dot"></i>{{ $t('live.live') }}</span>
                <span v-if="tEvent.live_room.status !== 'ENDED'" class="tw-text-white tw-text-center tw-px-4 tw-py-2 tw-opacity-40 backdrop-filter tw-rounded-lg tw-mt-8 md:tw-hidden">
                    <i class="far fa-lg fa-mobile tw-mr-2"></i>
                    {{ $t('live.no_mobile') }}
                </span>
			</div>

			<div v-else class="tw-flex tw-items-center">
				<calendar-icon size="large" :tEvent="tEvent" :format="format"></calendar-icon>
				<div class="tw-flex tw-flex-1 tw-justify-between tw-ml-4">
					<div class="tw-flex tw-flex-col tw-flex-1 tw-justify-center">
						<div class="group-title tw-text-lg tw-flex tw-items-center tw-mb-2">
							<h1 v-line-clamp:23="2" v-text="tEvent.title" class="tw-font-semibold"></h1>
						</div>
						<p class="tw-text-sm" :class="tEvent.image !== '' ? 'tw-text-white tw-opacity-75' : 'tw-text-gray-500'" v-text="start_date"></p>
					</div>
					<div class="tw-flex tw-items-center" v-if="tEvent.founder !== null">
						<div class="tw-flex tw-flex-col tw-mr-3 tw-text-sm tw-text-right">
							<span class="tw-mb-1">Organisator</span>
							<p class="tw-font-semibold" v-text="tEvent.founder.username"></p>
						</div>
						<img id="event-founder-icon" class="tw-rounded-full" :src="tEvent.founder.avatar">
					</div>
				</div>
			</div>
		</template>
	</event-header>
</template>

<script>
import moment from 'moment';
import EventHeader from '../../components/events_and_groups/Header.vue';
import CalendarIcon from '../../components/events/CalendarIcon.vue';
import Global from '../../mixins/Global';
import Countdown from "../ui/Countdown";

export default {
	name: 'EventsHeader',

	components: {
		'countdown': Countdown,
		'event-header': EventHeader,
		'calendar-icon': CalendarIcon,
	},

	mixins: [Global],

	props: {
		tEvent: {
			required: true,
		},

		editing: {
			required: true,
		},

		apply_live_style: {
			required: false,
			default: false,
		}
	},

    data() {
        return {
            start_date_has_passed: false,
        }
    },

	computed: {
		format() {
			if (moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm', true).isValid()) {
				return 'MMMM DD, YYYY HH:mm';
			} else {
				return 'YYYY-MM-DD HH:mm';
			}
		},

		start_date() {
			let format;
			if (moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm', true).isValid()) {
				format = 'MMMM DD, YYYY HH:mm';
			} else {
				format = 'YYYY-MM-DD HH:mm';
			}

			const start_date = moment(this.tEvent.start_date, format).format('dddd D MMMM YYYY');

			return start_date.charAt(0).toUpperCase() + start_date.slice(1);
		},
	},

    mounted() {
        this.start_date_has_passed = moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').isBefore(moment());
    }
};
</script>

<style lang="scss" scoped>
#event-founder-icon {
	width: 42px;
	height: 42px;
}

.countdown-finished-message {
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(50px);
    font-weight: 600;
    color: white;
    font-size: 1rem;
    line-height: 200%;
    padding: 8px 16px;
}

.backdrop-filter {
    backdrop-filter: blur(20px);
}

.live-dot {
    animation: live 3500ms 3 ease-in-out;
}

@keyframes live {
    0% {
        @apply tw-text-red-500;
    }
    15% {
        @apply tw-text-red-300;
    }
    30% {
        @apply tw-text-red-500;
    }
    100% {
        @apply tw-text-red-500;
    }
}
</style>
